"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classnames = _interopRequireDefault(require("classnames"));

var _lodash = _interopRequireDefault(require("lodash"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _userMenu = _interopRequireDefault(require("./user-menu"));

var _userUtil = require("../../util/user-util");

var _navigationItem = _interopRequireDefault(require("./navigation-item"));

var _svg = _interopRequireDefault(require("../svg"));

var _onClickOutside = _interopRequireDefault(require("../on-click-outside"));

require("./top-nav.less");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var userPropType = _propTypes["default"].shape({
  first_name: _propTypes["default"].string,
  last_name: _propTypes["default"].string
});

var routePropType = _propTypes["default"].shape({
  link: _propTypes["default"].node,
  separator: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool
});
/**
 * Top Navigation for a Glowforge site.
 * This is currently used by ecomm and discover pages. It provides different
 * styles for marketing pages vs. shop/catalog/order pages. The contents of the
 * nav bar are controlled by several configuration properties that contain
 * information about what routes should be linked to from different sections of
 * the nav bar. The main sections, from left to right, are:
 *  - Logo -  the Glowforge logo bug is a link controlled by a simple url passed
 *    as logoLink.
 *  - Primary Tabs - the main navigational links that take up most of the nav
 *    bar. These are expected as an array of routes (see routePropType).
 *  - Button Section - attached to the right side of the navbar, the button
 *    section provides a prominent call to action for an entire page. This is
 *    implemented as the buttonSection prop, which expects a React node since
 *    its implementation is very differnt depending on the client.
 *  - User Menu - at the far right is the user menu, which has a set of fixed
 *    routes (settings, logout, and login) as well as an array of secondary
 *    routes. See user-menu.jsx for more details.
 *
 * Also see top-nav.sandbox.jsx for example usage of the TopNav component.
 */


var TopNav =
/*#__PURE__*/
function (_Component) {
  _inherits(TopNav, _Component);

  function TopNav(props) {
    var _this;

    _classCallCheck(this, TopNav);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TopNav).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "getUserSection", function () {
      var _this$props = _this.props,
          user = _this$props.user,
          hideUserSection = _this$props.hideUserSection,
          userRoutes = _this$props.userRoutes,
          userSecondaryLinks = _this$props.userSecondaryLinks,
          NavigationItem = _this$props.NavigationItem;
      if (hideUserSection) return null; // User is in pending state if user is undefined (default prop)
      // User is either an empty object (not signed in) or an object with data (signed in)
      // This allows a fade in of the sign in link, which prevents the `Buy Now` from jumping
      // Only apparent on pages that don't preload user data on server

      var pendingUser = user === undefined;

      if (_lodash["default"].isEmpty(user) || pendingUser) {
        return _react["default"].createElement("span", {
          className: (0, _classnames["default"])('signIn', {
            pendingUser: pendingUser
          })
        }, _react["default"].createElement(NavigationItem, {
          tab: userRoutes.login,
          className: "clearLink"
        }));
      }

      return _react["default"].createElement(_userMenu["default"], {
        routes: userRoutes,
        secondaryLinks: userSecondaryLinks,
        user: user
      });
    });

    _defineProperty(_assertThisInitialized(_this), "mobileUserSection", function () {
      var _this$props2 = _this.props,
          hideUserSection = _this$props2.hideUserSection,
          userRoutes = _this$props2.userRoutes,
          user = _this$props2.user;
      if (hideUserSection) return []; // user signed in routes.

      if (!_lodash["default"].isEmpty(user)) {
        return [{
          separator: true,
          mobileOnly: true
        }, _objectSpread({}, userRoutes.settings, {
          text: (0, _userUtil.userFullName)(user),
          mobileOnly: true
        }), _objectSpread({}, userRoutes.referrals, {
          mobileOnly: true
        }), _objectSpread({}, userRoutes.logout, {
          mobileOnly: true
        })];
      } // user not signed in routes


      return [{
        separator: true,
        mobileOnly: true
      }, _objectSpread({}, userRoutes.login, {
        mobileOnly: true
      })];
    });

    _defineProperty(_assertThisInitialized(_this), "getNavigationItems", function () {
      var _this$props3 = _this.props,
          primaryRoutes = _this$props3.primaryRoutes,
          NavigationItem = _this$props3.NavigationItem;
      return (0, _lodash["default"])(primaryRoutes.concat(_this.mobileUserSection())).filter(function (tab) {
        return !tab.disabled;
      }).map(function (tab, index) {
        return _react["default"].createElement("li", {
          className: "item ".concat(tab.mobileOnly ? 'mobile-only' : ''),
          key: tab.url || index
        }, _react["default"].createElement(NavigationItem, {
          tab: tab,
          onClick: _this.closeNav,
          className: "clearLink"
        }));
      }).value();
    });

    _defineProperty(_assertThisInitialized(_this), "toggleNav", function () {
      var showMobileNav = _this.state.showMobileNav;

      _this.setState({
        showMobileNav: !showMobileNav
      });
    });

    _defineProperty(_assertThisInitialized(_this), "closeNav", function () {
      _this.setState({
        showMobileNav: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleClickOutside", function () {
      _this.closeNav();
    });

    _this.state = {
      showMobileNav: false
    };
    return _this;
  }
  /**
   * Gets the user section if signed in, otherwise shows a login tab.
   * If hidden, returns null.
   * @returns {Node}
   */


  _createClass(TopNav, [{
    key: "render",
    value: function render() {
      var navItems = this.getNavigationItems();
      var userSection = this.getUserSection();
      var _this$props4 = this.props,
          hideNavLinks = _this$props4.hideNavLinks,
          marketing = _this$props4.marketing,
          logoLink = _this$props4.logoLink,
          buttonSection = _this$props4.buttonSection;
      var showMobileNav = this.state.showMobileNav; // Show menu button if nav links explicitly hidden or there are nav items to show

      var menuButton = hideNavLinks || !_lodash["default"].isEmpty(navItems) ? _react["default"].createElement(_svg["default"], {
        className: "menuButton",
        id: "menu",
        onClick: this.toggleNav
      }) : null;
      var userSectionClasses = (0, _classnames["default"])('userSection', {
        'mobile-hidden': !_lodash["default"].isEmpty(navItems)
      });
      var navClassses = (0, _classnames["default"])('TopNav', {
        noNavLinks: _lodash["default"].isEmpty(navItems),
        MarketingNavigation: marketing
      });
      var tabsClasses = (0, _classnames["default"])('tabs', {
        show: showMobileNav
      });
      return _react["default"].createElement("div", {
        role: "navigation",
        className: navClassses
      }, _react["default"].createElement("div", {
        className: "icon brand"
      }, _react["default"].createElement("a", {
        href: logoLink,
        className: "logo"
      }, _react["default"].createElement(_svg["default"], {
        id: "glowforge-icon"
      }))), _react["default"].createElement("ul", {
        className: tabsClasses
      }, navItems), _react["default"].createElement("div", {
        className: "menuSection"
      }, buttonSection, _react["default"].createElement("div", {
        className: userSectionClasses
      }, userSection), menuButton));
    }
  }]);

  return TopNav;
}(_react.Component);

_defineProperty(TopNav, "propTypes", {
  logoLink: _propTypes["default"].string,
  user: userPropType,
  userRoutes: _propTypes["default"].objectOf(routePropType),
  userSecondaryLinks: _propTypes["default"].arrayOf(routePropType),
  primaryRoutes: _propTypes["default"].arrayOf(routePropType),
  buttonSection: _propTypes["default"].node,
  hideNavLinks: _propTypes["default"].bool,
  hideUserSection: _propTypes["default"].bool,
  marketing: _propTypes["default"].bool,
  NavigationItem: _propTypes["default"].func
});

_defineProperty(TopNav, "defaultProps", {
  user: undefined,
  logoLink: 'https://glowforge.com',
  userRoutes: {},
  userSecondaryLinks: [],
  primaryRoutes: [],
  buttonSection: null,
  hideNavLinks: false,
  hideUserSection: false,
  marketing: false,
  NavigationItem: _navigationItem["default"]
});

var _default = (0, _onClickOutside["default"])(TopNav);

exports["default"] = _default;